/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircuitCapacitor = createReactComponent(
  "circuit-capacitor",
  "IconCircuitCapacitor",
  [
    ["path", { d: "M22 12h-8", key: "svg-0" }],
    ["path", { d: "M2 12h8", key: "svg-1" }],
    ["path", { d: "M10 7v10", key: "svg-2" }],
    ["path", { d: "M14 7v10", key: "svg-3" }]
  ]
);

export { IconCircuitCapacitor as default };
//# sourceMappingURL=IconCircuitCapacitor.js.map
